module.exports = __webpack_public_path__ + "static/img/Ben-Rongdit.d08b1d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ben-Rongdit.jpg
// module id = VIxG
// module chunks = 0